export default "__VITE_ASSET__BuFJAuSs__"